import { Adapter } from './adapter';
import { Location } from '../models/_index';
import { LocationInterface } from '@app/interfaces/_index';

/**
 * Adapt raw Docebo location object to Location model
 * NOTE: The item fields are the default json property names.
 */
export class LocationAdapter implements Adapter<Location> {
  /**
   * Adapt data item into a Location model.
   * @param item - data item Location Interface to be transformed
   * @returns - returns an adapted Location model
   */
  adapt(item: LocationInterface): Location {
    let location: Location;

    if (item) {
      location = new Location(
        item.accomodations, // Not currently being used
        item.address,
        item.email, // Not currently being used
        item.id_country, // Not currently being used
        item.id_location, // Not currently being used
        item.id_zone, // Not currently being used
        item.iso_code_country, // Not currently being used
        item.name,
        item.name_country, // Not currently being used
        item.other_info, // Not currently being used
        item.reaching_info, // Not currently being used
        item.telephone // Not currently being used
      );
    }

    return location;
  }
}
